/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminDisconnectStravaDto } from '../model';
// @ts-ignore
import type { AdminDisconnectStravaResponseDto } from '../model';
// @ts-ignore
import type { DashboardStatsDto } from '../model';
// @ts-ignore
import type { EventRevenueDetailedDto } from '../model';
// @ts-ignore
import type { EventRevenueDetailsDto } from '../model';
// @ts-ignore
import type { PaginatedAdminUserListDto } from '../model';
// @ts-ignore
import type { RevenueDashboardDto } from '../model';
// @ts-ignore
import type { RevenueEventOptionDto } from '../model';
/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Disconnects a user from Strava and calls Strava deauthorization API. Only works if user has no active event participations. Only accessible by Super Admins.
         * @summary Disconnect user from Strava (Admin only)
         * @param {AdminDisconnectStravaDto} adminDisconnectStravaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerAdminDisconnectUserFromStrava: async (adminDisconnectStravaDto: AdminDisconnectStravaDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminDisconnectStravaDto' is not null or undefined
            assertParamExists('dashboardControllerAdminDisconnectUserFromStrava', 'adminDisconnectStravaDto', adminDisconnectStravaDto)
            const localVarPath = `/api/dashboard/admin/disconnect-strava`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminDisconnectStravaDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a paginated list of users with their Strava connection status and active events. Only accessible by Super Admins.
         * @summary Get paginated list of users for admin management
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Items per page
         * @param {string} [search] Search term for name or email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerGetAdminUserList: async (page?: number, limit?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get dashboard statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerGetDashboardStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns detailed revenue data for a specific event with paginated participant payments including custom entitlements. Admins can access all events, organizers can only access their events.
         * @summary Get detailed revenue data with paginated participant payments for a specific event
         * @param {string} eventId Event ID
         * @param {number} [page] Page number for pagination
         * @param {number} [limit] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerGetEventRevenueDetailed: async (eventId: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('dashboardControllerGetEventRevenueDetailed', 'eventId', eventId)
            const localVarPath = `/api/dashboard/revenue/events/{eventId}/detailed`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns detailed revenue breakdown with participant-level data for a specific event. Admins can access all events, organizers can only access their events.
         * @summary Get detailed revenue data for a specific event
         * @param {string} eventId Event ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerGetEventRevenueDetails: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('dashboardControllerGetEventRevenueDetails', 'eventId', eventId)
            const localVarPath = `/api/dashboard/revenue/events/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns revenue breakdown by event with organizer and platform revenue splits. Admins see all events, organizers see only their events.
         * @summary Get revenue dashboard data
         * @param {string} [eventId] Event ID to filter revenue data (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerGetRevenueDashboard: async (eventId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/revenue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventId !== undefined) {
                localVarQueryParameter['eventId'] = eventId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns list of events with paid participants for revenue dashboard filtering. Admins see all events, organizers see only their events.
         * @summary Get list of events for revenue dashboard filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerGetRevenueEventOptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/revenue/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * Disconnects a user from Strava and calls Strava deauthorization API. Only works if user has no active event participations. Only accessible by Super Admins.
         * @summary Disconnect user from Strava (Admin only)
         * @param {AdminDisconnectStravaDto} adminDisconnectStravaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardControllerAdminDisconnectUserFromStrava(adminDisconnectStravaDto: AdminDisconnectStravaDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDisconnectStravaResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardControllerAdminDisconnectUserFromStrava(adminDisconnectStravaDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.dashboardControllerAdminDisconnectUserFromStrava']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a paginated list of users with their Strava connection status and active events. Only accessible by Super Admins.
         * @summary Get paginated list of users for admin management
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Items per page
         * @param {string} [search] Search term for name or email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardControllerGetAdminUserList(page?: number, limit?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedAdminUserListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardControllerGetAdminUserList(page, limit, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.dashboardControllerGetAdminUserList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get dashboard statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardControllerGetDashboardStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardControllerGetDashboardStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.dashboardControllerGetDashboardStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns detailed revenue data for a specific event with paginated participant payments including custom entitlements. Admins can access all events, organizers can only access their events.
         * @summary Get detailed revenue data with paginated participant payments for a specific event
         * @param {string} eventId Event ID
         * @param {number} [page] Page number for pagination
         * @param {number} [limit] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardControllerGetEventRevenueDetailed(eventId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventRevenueDetailedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardControllerGetEventRevenueDetailed(eventId, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.dashboardControllerGetEventRevenueDetailed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns detailed revenue breakdown with participant-level data for a specific event. Admins can access all events, organizers can only access their events.
         * @summary Get detailed revenue data for a specific event
         * @param {string} eventId Event ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardControllerGetEventRevenueDetails(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventRevenueDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardControllerGetEventRevenueDetails(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.dashboardControllerGetEventRevenueDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns revenue breakdown by event with organizer and platform revenue splits. Admins see all events, organizers see only their events.
         * @summary Get revenue dashboard data
         * @param {string} [eventId] Event ID to filter revenue data (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardControllerGetRevenueDashboard(eventId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RevenueDashboardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardControllerGetRevenueDashboard(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.dashboardControllerGetRevenueDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns list of events with paid participants for revenue dashboard filtering. Admins see all events, organizers see only their events.
         * @summary Get list of events for revenue dashboard filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardControllerGetRevenueEventOptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RevenueEventOptionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardControllerGetRevenueEventOptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.dashboardControllerGetRevenueEventOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * Disconnects a user from Strava and calls Strava deauthorization API. Only works if user has no active event participations. Only accessible by Super Admins.
         * @summary Disconnect user from Strava (Admin only)
         * @param {AdminDisconnectStravaDto} adminDisconnectStravaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerAdminDisconnectUserFromStrava(adminDisconnectStravaDto: AdminDisconnectStravaDto, options?: RawAxiosRequestConfig): AxiosPromise<AdminDisconnectStravaResponseDto> {
            return localVarFp.dashboardControllerAdminDisconnectUserFromStrava(adminDisconnectStravaDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a paginated list of users with their Strava connection status and active events. Only accessible by Super Admins.
         * @summary Get paginated list of users for admin management
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Items per page
         * @param {string} [search] Search term for name or email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerGetAdminUserList(page?: number, limit?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedAdminUserListDto> {
            return localVarFp.dashboardControllerGetAdminUserList(page, limit, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get dashboard statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerGetDashboardStats(options?: RawAxiosRequestConfig): AxiosPromise<DashboardStatsDto> {
            return localVarFp.dashboardControllerGetDashboardStats(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns detailed revenue data for a specific event with paginated participant payments including custom entitlements. Admins can access all events, organizers can only access their events.
         * @summary Get detailed revenue data with paginated participant payments for a specific event
         * @param {string} eventId Event ID
         * @param {number} [page] Page number for pagination
         * @param {number} [limit] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerGetEventRevenueDetailed(eventId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<EventRevenueDetailedDto> {
            return localVarFp.dashboardControllerGetEventRevenueDetailed(eventId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns detailed revenue breakdown with participant-level data for a specific event. Admins can access all events, organizers can only access their events.
         * @summary Get detailed revenue data for a specific event
         * @param {string} eventId Event ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerGetEventRevenueDetails(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<EventRevenueDetailsDto> {
            return localVarFp.dashboardControllerGetEventRevenueDetails(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns revenue breakdown by event with organizer and platform revenue splits. Admins see all events, organizers see only their events.
         * @summary Get revenue dashboard data
         * @param {string} [eventId] Event ID to filter revenue data (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerGetRevenueDashboard(eventId?: string, options?: RawAxiosRequestConfig): AxiosPromise<RevenueDashboardDto> {
            return localVarFp.dashboardControllerGetRevenueDashboard(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns list of events with paid participants for revenue dashboard filtering. Admins see all events, organizers see only their events.
         * @summary Get list of events for revenue dashboard filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerGetRevenueEventOptions(options?: RawAxiosRequestConfig): AxiosPromise<Array<RevenueEventOptionDto>> {
            return localVarFp.dashboardControllerGetRevenueEventOptions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
    /**
     * Disconnects a user from Strava and calls Strava deauthorization API. Only works if user has no active event participations. Only accessible by Super Admins.
     * @summary Disconnect user from Strava (Admin only)
     * @param {AdminDisconnectStravaDto} adminDisconnectStravaDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public dashboardControllerAdminDisconnectUserFromStrava(adminDisconnectStravaDto: AdminDisconnectStravaDto, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).dashboardControllerAdminDisconnectUserFromStrava(adminDisconnectStravaDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a paginated list of users with their Strava connection status and active events. Only accessible by Super Admins.
     * @summary Get paginated list of users for admin management
     * @param {number} [page] Page number (1-based)
     * @param {number} [limit] Items per page
     * @param {string} [search] Search term for name or email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public dashboardControllerGetAdminUserList(page?: number, limit?: number, search?: string, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).dashboardControllerGetAdminUserList(page, limit, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get dashboard statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public dashboardControllerGetDashboardStats(options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).dashboardControllerGetDashboardStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns detailed revenue data for a specific event with paginated participant payments including custom entitlements. Admins can access all events, organizers can only access their events.
     * @summary Get detailed revenue data with paginated participant payments for a specific event
     * @param {string} eventId Event ID
     * @param {number} [page] Page number for pagination
     * @param {number} [limit] Number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public dashboardControllerGetEventRevenueDetailed(eventId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).dashboardControllerGetEventRevenueDetailed(eventId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns detailed revenue breakdown with participant-level data for a specific event. Admins can access all events, organizers can only access their events.
     * @summary Get detailed revenue data for a specific event
     * @param {string} eventId Event ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public dashboardControllerGetEventRevenueDetails(eventId: string, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).dashboardControllerGetEventRevenueDetails(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns revenue breakdown by event with organizer and platform revenue splits. Admins see all events, organizers see only their events.
     * @summary Get revenue dashboard data
     * @param {string} [eventId] Event ID to filter revenue data (optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public dashboardControllerGetRevenueDashboard(eventId?: string, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).dashboardControllerGetRevenueDashboard(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns list of events with paid participants for revenue dashboard filtering. Admins see all events, organizers see only their events.
     * @summary Get list of events for revenue dashboard filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public dashboardControllerGetRevenueEventOptions(options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).dashboardControllerGetRevenueEventOptions(options).then((request) => request(this.axios, this.basePath));
    }
}

